module.exports = __webpack_public_path__ + "img/duplicate.c27abd89.svg";